// extracted by mini-css-extract-plugin
export default {"btn":"AuthButton_btn__-k52D","active":"AuthButton_active__hn-WC","profile":"AuthButton_profile__dBJwZ","photo-url":"AuthButton_photo-url__xZkQf"};